/**
 * Product card image slider: one image at a time, prev/next arrows + dots on left
 * Uses event delegation so it works after facet/filter updates replace the product grid.
 * Supports touch/swipe gestures for mobile devices.
 */
(function () {
  const SLIDER_SELECTOR = '[data-product-card-slider]';
  const SWIPE_THRESHOLD = 50; // minimum distance in pixels to trigger a swipe
  const SWIPE_TIME_LIMIT = 500; // maximum time in ms for a swipe gesture

  // Touch state tracking
  const touchState = {
    startX: 0,
    startY: 0,
    startTime: 0,
    container: null
  };

  function getSliderContainer(el) {
    return el && el.closest(SLIDER_SELECTOR);
  }

  function goToSlide(container, index) {
    const slides = container.querySelectorAll('.product-card__image-slider__slide');
    const dots = container.querySelectorAll('.product-card__image-slider__dot');
    if (slides.length <= 1) return;

    const len = slides.length;
    const currentIndex = ((index % len) + len) % len;

    slides.forEach((slide, i) => {
      const isActive = i === currentIndex;
      slide.classList.toggle('is-active', isActive);
      slide.hidden = !isActive;
    });

    dots.forEach((dot, i) => {
      const isActive = i === currentIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function getCurrentIndex(container) {
    const active = container.querySelector('.product-card__image-slider__slide.is-active');
    const slides = container.querySelectorAll('.product-card__image-slider__slide');
    for (let i = 0; i < slides.length; i++) {
      if (slides[i] === active) return i;
    }
    return 0;
  }

  // Click event handler for buttons and dots
  document.addEventListener('click', function (e) {
    const prevBtn = e.target.closest('[data-slider-prev]');
    const nextBtn = e.target.closest('[data-slider-next]');
    const dot = e.target.closest('.product-card__image-slider__dot');

    const container = getSliderContainer(prevBtn || nextBtn || dot);
    if (!container) return;

    e.preventDefault();
    e.stopPropagation();

    const slides = container.querySelectorAll('.product-card__image-slider__slide');
    if (slides.length <= 1) return;

    if (prevBtn) {
      goToSlide(container, getCurrentIndex(container) - 1);
    } else if (nextBtn) {
      goToSlide(container, getCurrentIndex(container) + 1);
    } else if (dot) {
      const index = parseInt(dot.getAttribute('data-slide-to'), 10);
      if (!isNaN(index)) goToSlide(container, index);
    }
  });

  // Touch start handler
  document.addEventListener('touchstart', function (e) {
    const track = e.target.closest('.product-card__image-slider__track');
    if (!track) return;

    const container = getSliderContainer(track);
    if (!container) return;

    const slides = container.querySelectorAll('.product-card__image-slider__slide');
    if (slides.length <= 1) return;

    const touch = e.touches[0];
    touchState.startX = touch.clientX;
    touchState.startY = touch.clientY;
    touchState.startTime = Date.now();
    touchState.container = container;
  }, { passive: true });

  // Touch end handler
  document.addEventListener('touchend', function (e) {
    if (!touchState.container) return;

    const touch = e.changedTouches[0];
    const endX = touch.clientX;
    const endY = touch.clientY;
    const endTime = Date.now();

    const deltaX = endX - touchState.startX;
    const deltaY = endY - touchState.startY;
    const deltaTime = endTime - touchState.startTime;

    // Check if it's a valid swipe gesture
    const isHorizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY);
    const isQuickEnough = deltaTime < SWIPE_TIME_LIMIT;
    const isLongEnough = Math.abs(deltaX) > SWIPE_THRESHOLD;

    if (isHorizontalSwipe && isQuickEnough && isLongEnough) {
      const currentIndex = getCurrentIndex(touchState.container);
      
      if (deltaX > 0) {
        // Swiped right, go to previous slide
        goToSlide(touchState.container, currentIndex - 1);
      } else {
        // Swiped left, go to next slide
        goToSlide(touchState.container, currentIndex + 1);
      }
    }

    // Reset touch state
    touchState.startX = 0;
    touchState.startY = 0;
    touchState.startTime = 0;
    touchState.container = null;
  }, { passive: true });

  // Touch cancel handler (in case touch is interrupted)
  document.addEventListener('touchcancel', function () {
    touchState.startX = 0;
    touchState.startY = 0;
    touchState.startTime = 0;
    touchState.container = null;
  }, { passive: true });
})();
